import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { RefreshIndicator } from 'material-ui';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import environment from '../../relay/environment';
import ResponseDetail from './ResponseDetail';

@connect(state => ({
  windowHeight: state.Responsive.get('windowHeight'),
}))
class ResponseDetailsRenderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    activeResponse: PropTypes.string.isRequired,
  }

  render() {
    const { windowHeight, activeResponse } = this.props;
    const top = ((windowHeight - 161) / 2) + 161;

    const loadingEl = (<RefreshIndicator
      top={top}
      left={900}
      status='loading'
    />);

    return (<QueryRenderer
      environment={environment}
      variables={{
        responseId: activeResponse,
      }}
      query={graphql`
        query ResponseDetailsRenderer_ResponseDetails_Query($responseId: ID!) {
          response(id: $responseId) {
            savedSchema,
            savedUiSchema,
            response,
            simpleDisplay
          }
        }
      `}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { response } = props;

          return <ResponseDetail response={response} />;
        }

        return loadingEl;
      }}
    />);
  }
}

export default ResponseDetailsRenderer;



// WEBPACK FOOTER //
// /src/components/Forms/ResponseDetailsRenderer.js